module.exports = __webpack_public_path__ + "static/website-icon-1af5a389d3aeaf8f26f65bcfb81877ff.png";